<script lang="ts">
	import { createEventDispatcher, getContext } from "svelte";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import type { Field } from "#gen/forms/v1/field_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import P from "#lib/components/P.svelte";
	import TokenizedText from "#lib/components/TokenizedText.svelte";
	import PlaintextEditor from "#lib/components/content-editors/PlaintextEditor.svelte";
	import type { TypeIcon } from "#lib/components/page/components/form/FieldProps.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import type { Writable } from "svelte/store";

	interface $$Events {
		input: CustomEvent<Field>;
		change: CustomEvent<Field>;
	}

	const dispatch = createEventDispatcher();
	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");

	export let typeIcon: TypeIcon | undefined = undefined;
	export let field: Field;
	export let editable = false;
	export let mode: Mode = Mode.LIVE;

	$: showTokenizedPreview = mode === Mode.EDITING && $tokenProvider.hasSubstitutionToken(field.title);

	function handleInput() {
		dispatch("input", field);
	}

	function handleFieldChange() {
		dispatch("change", field);
	}
</script>

<div {...$$restProps}>
	<div class="flex items-center gap-4">
		{#if editable && typeIcon}
			<div class="rounded-lg p-2 text-center" style="background-color: {typeIcon.accentColor};">
				<Icon name={typeIcon.icon} iconSet={typeIcon.iconSet} class="m-auto h-5 w-5" />
			</div>
		{/if}
		<div class="grow">
			{#if editable && !field.immutable}
				<PlaintextEditor provider={$tokenProvider} bind:value={field.title} on:input={handleInput} on:change={handleFieldChange} />
			{:else if showTokenizedPreview}
				<h6 class="form-header-text mt-4 w-full pb-0 text-lg font-semibold">
					<TokenizedText provider={$tokenProvider} text={field.title} {mode} />
				</h6>
			{:else}
				<h6 class="form-header-text mt-4 w-full pb-0 text-lg font-semibold">{field.title}</h6>
			{/if}
			{#if field.description}
				<P>{field.description}</P>
			{/if}
		</div>
	</div>
</div>
